import React from 'react'

import { Card, Grid, Typography, Button, Collapse } from '@mui/material'
import { AddCircleOutline, ExpandMore } from '@mui/icons-material'
import TaskRecommendations from 'layouts/authenticated/pages/dashboard/components/TaskRecommendations'
import AppointmentScheduler from 'components/AppointmentScheduler'

function AdminScheduleAppointment({ collapseSections, toggleCollapse }) {
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.todo}
                style={{ width: '100%' }}
              ></Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="scheduleAppointment"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('schedule')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Schedule Appointment
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.schedule
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.schedule} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} xxl={6}>
                <AppointmentScheduler isAdmin={true} />
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default AdminScheduleAppointment
